export const CURRENT_FEEDBACK_UI_VERSION = "2026-06-w1l1-recalibration-v3";

export function buildLegacySubmissionRecoveryKey(studentId, weekNumber, lessonNumber) {
  const sid = String(studentId || "").trim();
  const week = Number(weekNumber) || 0;
  const lesson = Number(lessonNumber) || 0;
  if (!sid || !week || !lesson) return "";
  return `pending_submission:${sid}:W${week}:L${lesson}`;
}

export function buildSubmissionRecoveryKey(studentId, weekNumber, lessonNumber) {
  const sid = String(studentId || "").trim();
  const week = Number(weekNumber) || 0;
  const lesson = Number(lessonNumber) || 0;
  if (!sid || !week || !lesson) return "";
  return `pending_submission:${sid}:W${week}:L${lesson}:v=${CURRENT_FEEDBACK_UI_VERSION}`;
}

export function getSubmissionRecoveryKeys(studentId, weekNumber, lessonNumber) {
  const currentKey = buildSubmissionRecoveryKey(studentId, weekNumber, lessonNumber);
  const legacyKey = buildLegacySubmissionRecoveryKey(studentId, weekNumber, lessonNumber);
  return [currentKey, legacyKey].filter(Boolean);
}

export function getFeedbackUiVersion(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return "";
  const direct = String(payload.evaluation_version || payload.feedback_ui_version || "").trim();
  if (direct) return direct;
  const result = payload.result_json;
  if (result && typeof result === "object" && !Array.isArray(result)) {
    return String(result.evaluation_version || result.feedback_ui_version || "").trim();
  }
  return "";
}

export function isFreshFeedbackPayload(payload) {
  const version = getFeedbackUiVersion(payload);
  return version === CURRENT_FEEDBACK_UI_VERSION;
}
